export const DEFAULT_LOCATION_COUNT = 3;
